import { createReducer, on } from '@ngrx/store';

import {
  BusinessPartner,
  BusinessPartnerBackofficeModuleState,
} from '../../models/business-partner-backoffice.model';
import * as labresultActions from '../actions/business-partner-backoffice.actions';

export const businessPartnerBackofficeReducer = createReducer<BusinessPartnerBackofficeModuleState>(
  {} as BusinessPartnerBackofficeModuleState,
  on(labresultActions.getBusinessPartnersSuccess, (state, { businessPartners, pagination }) => ({
    ...state,
    businessPartners,
    pagination,
  })),
  on(labresultActions.businessPartnersNotFound, (state) => ({
    ...state,
    loadResult: false,
    businessPartners: [] as BusinessPartner[],
  })),
);
